// extracted by mini-css-extract-plugin
export var externalLink = "_a0-0";
export var internalLinkLabel = "_a0-1";